/*
 * @Description: 任务工单相关接口
 * @Author: black-k
 * @Date: 2025-08-29 17:56:25
 * @LastEditors: black-k
 * @LastEditTime: 2025-09-22 09:19:38
 */
const taskApi = {
    // public
    taskList: "tasks/ListTasks", // 任务列表
    saveTask: "tasks/SaveTask", // 保存任务
    getTask: "tasks/GetTask", // 获取任务详情
    deleteTask: "tasks/DeleteTask", // 删除任务
    taskApplyList: "tasks/teacher/taskApplyList", // 报名学生列表
    taskResultList: "tasks/teacher/taskResultList", // 任务成果列表
    taskEvaluate: "tasks/student/taskEvaluate", // 验收任务, 评价任务

    // company | teacher
    changeApplyStatus: "tasks/teacher/changeTaskApplyStatus", // 修改学生报名状态
    taskContracts: "tasks/teacher/taskContracts", // 发起合同签订
    taskRework: "tasks/teacher/taskRework", // 任务成果返工

    // student
    stuTaskContracts: "tasks/student/acceptContract", // 学生接受合同
    stuStopContract: "tasks/student/stopContract", // 学生终止合同
    stuSubmitTask: "tasks/student/submitTaskResult", // 学生提交任务成果
    taskApplyInfo: "tasks/student/taskApplyInfo", // 任务报名详情
    taskCancelApply: "tasks/student/taskCancelApply", // 取消报名
    taskApply: "tasks/student/taskApply", // 学会生报名、修改报名

    // teacher
    studentTaskInfo: "tasks/teacher/studentTaskInfo", // 学生接单数据
    studentTaskList: "tasks/ListTasks", // 学生完成任务列表
    studentTodo: "tasks/student/tasksTodo", // 学生待办列表
    studentMoney: "tasks/student/getUserInfo", // 学生金币
};

export default taskApi;
